import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const BaroqueShirtBlack = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.BaroqueShirtBlack.itemName}
      name={AW23.tops.BaroqueShirtBlack.itemName}
      price={AW23.tops.BaroqueShirtBlack.itemPrice}
      fabric={AW23.tops.BaroqueShirtBlack.itemFabric}
      src={AW23.tops.BaroqueShirtBlack.sizeChart}
      divId={AW23.tops.BaroqueShirtBlack.shopifyDivId}
      mainId={AW23.tops.BaroqueShirtBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.BaroqueShirtBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.BaroqueShirtBlack.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default BaroqueShirtBlack;
